<script setup lang="ts">
import { CloseRingIcon, TimeIcon } from "@kaleidoscope-solutions/ks-icons/vue/light"
import { onClickOutside } from "@vueuse/core"
import { ref, useTemplateRef } from "vue"
import { usePlaygroundStore } from "@/stores/playground"

const emit = defineEmits<{
  (event: "optionClicked", value: string): void
}>()

const playgroundStore = usePlaygroundStore()

const history = playgroundStore.history

const showHistory = ref(false)

function historyOptionClicked(text: string) {
  // Ignore history click if text is selected in the browser
  if (window.getSelection && window.getSelection()?.toString()) {
    return
  }

  emit("optionClicked", text)
  showHistory.value = false
}

function removeItemFromHistory(index: number) {
  playgroundStore.removeItemFromHistory(index)
}

const historyRef = useTemplateRef("historyRef")

function closeHistory() {
  showHistory.value = false
}

onClickOutside(historyRef, closeHistory, { ignore: ["[data-time-icon]"] })
</script>

<template>
  <div class="relative">
    <TimeIcon
      data-time-icon
      class="size-7 cursor-pointer text-violet-700"
      @click="showHistory = !showHistory"
    />
    <div
      v-if="showHistory"
      ref="historyRef"
      class="absolute top-8 z-10 max-h-[800px] min-w-[700px] overflow-auto rounded-lg bg-white shadow-lg"
    >
      <div class="flex flex-col">
        <div class="sticky top-0 flex items-center gap-2 rounded-lg bg-white p-2 px-4 py-2">
          <span class="text-lg">
            Formula History
          </span>
        </div>
        <ul class="flex flex-col gap-2 p-4 pt-0">
          <li
            v-for="(text, index) in history"
            :key="index"
            class="flex items-center justify-between gap-2"
          >
            <span
              class="flex flex-1 cursor-pointer justify-between rounded-lg border border-gray-600 p-2 whitespace-break-spaces hover:bg-gray-200"
              @click="historyOptionClicked(text)"
              v-text="text"
            />
            <CloseRingIcon
              class="pointer-events-auto size-6 cursor-pointer text-violet-700"
              @click.stop="removeItemFromHistory(index)"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
